import React from 'react';
import * as util from "../other/util.js";
import * as ICONS from "../other/icons.js"
import { GameData } from "../share/game-data.js";

export default class ResourcesInput extends React.Component {
    render() {
        return (
            <div>
                <ul className="resource-bar">
                    <li>{this.renderResource("worker")}</li>
                    <li>{this.renderResource("concrete")}</li>
                    <li>{this.renderResource("metal")}</li>
                    <li>{this.renderResource("plastic")}</li>
                    <li>{this.renderResource("fuel")}</li>
                </ul>
            </div>);
    }

    renderResource(res_id) {
        let res = GameData.RESOURCE_BY_ID[res_id];

        let have = this.props.have ? this.props.have[res.id] : undefined;
        let input = this.props.input[res.id];

        let available;
        if (have) {
            available = (<p> Available: {Math.floor(have)}</p>);
        }

        return (
            <div key={res.id} className="resource-tooltip" style={{ textAlign: "center" }}>
                <img src={ICONS.RESOURCES[res.id]} alt={res.ui_name} />
                <input value={input}
                    style={{ width: "40px", color: have < input ? "red" : undefined }}
                    onFocus={(event) => event.target.select()}
                    onChange={(event) => this.handleValueChange(event, res_id)} />
                <div className="resource-tooltiptext">
                    {res.ui_name}
                    {available}
                </div>
            </div>
        );
    }

    handleValueChange(event, res_id) {
        let new_input = util.clone(this.props.input);
        let value = event.target.value;
        if (!Number.isInteger(Number(value)) || value < 0) {
            value = 0;
        }
        new_input[res_id] = Number(value);
        this.props.onChange(new_input);
    }
}
